import { render, staticRenderFns } from "./ordersDetails.vue?vue&type=template&id=07256ab2&scoped=true&"
import script from "./ordersDetails.vue?vue&type=script&lang=js&"
export * from "./ordersDetails.vue?vue&type=script&lang=js&"
import style0 from "./ordersDetails.vue?vue&type=style&index=0&id=07256ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07256ab2",
  null
  
)

export default component.exports